import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-party-ink" data-id="element-55" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-56" data-mp="83m6jnddjcvt">
        <p className="inline-block rounded bg-party-rose px-2 py-0.5 font-sans text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-57" data-mp="m46o6g7jz2nq">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-white/80" data-id="element-58" data-mp="vv9ohfsnrdly">
          Puedes seguir guardando videos sobre globos, arcos, paneles, mesas y
          decoración sin saber qué deberías aprender primero. O puedes comenzar
          hoy a construir una nueva habilidad siguiendo una ruta organizada
          desde cero.
        </p>
        <h2 id="cierre" className="mt-1.5 font-display text-lg font-extrabold leading-tight text-white sm:text-2xl" data-id="element-59" data-mp="zua7ozf1si9h">
          No necesitas ser experto en decoración para empezar.{' '}
          <span className="text-party-gold" data-id="element-60" data-mp="2m2u9n49xfv6b">Necesitas dar el primer paso.</span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-party-gold bg-white p-3 text-party-ink" data-id="element-61" data-mp="2m570k6xnxfvi">
          <p className="font-sans text-[0.8rem] font-extrabold uppercase leading-tight text-party-rose sm:text-sm" data-id="element-62" data-mp="2v3sf7r00kar0">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-lg font-black" data-id="element-63" data-mp="300sn87gfbnkr">
            6 Tomos + 5 Bonos
          </p>
          <p className="text-[0.75rem] text-party-ink/75" data-id="element-64" data-mp="34vf0kg62fq7h">
            Valor de los bonos:{' '}
            <span className="text-party-rose line-through" data-id="element-65" data-mp="39rnddmwsj7bh">{BONUS_VALUE}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none text-party-rose sm:text-6xl" data-id="element-66" data-mp="3etco11g3piz1">
            Hoy: {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-67" data-mp="1jo3ftcizfx1e">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-semibold text-party-ink/75" data-id="element-68" data-mp="1eqjsln4b49xb">
            <span className="flex items-center gap-1" data-id="element-69" data-mp="1sihw9if91dm3">
              <ZapIcon size={12} className="text-party-rose" data-id="element-70" data-mp="1novpu7zoi5yq" />
              Acceso Inmediato
            </span>
            <span className="text-party-ink/40" data-id="element-71" data-mp="22d9soix3hufa">•</span>
            <span data-id="element-72" data-mp="1xg04f6lfzot1">Entrega Digital</span>
            <span className="text-party-ink/40" data-id="element-73" data-mp="1xeylyh23k01a">•</span>
            <span className="flex items-center gap-1" data-id="element-74" data-mp="2bf9ahdfxp2ja">
              <ShieldCheckIcon size={12} className="text-party-brown" data-id="element-75" data-mp="2beq48tznc2l3" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}